import React from "react";
import ReactMarkdown from "react-markdown";

export default function CheatSheet() {
  return <ReactMarkdown></ReactMarkdown>;
}
